import React from "react";
import styled from "styled-components/macro";
import { NavBarItemImageLinkProps } from "../types";

const StyledNavBarItemImageLink = styled.a`
  padding: 13px 16px;
  position: relative;
  top: 1.5px;
  text-align: center;
  text-decoration: none;
  svg {
    vertical-align: middle;
  }
`;

const NavBarItemImageLink = ({ image, route }: NavBarItemImageLinkProps) => (
  <StyledNavBarItemImageLink data-testid="NavBarItemImageLink" href={route}>
    {image}
  </StyledNavBarItemImageLink>
);

export default NavBarItemImageLink;
